import { render, staticRenderFns } from "./documents-actions.vue?vue&type=template&id=ac8b2d58&scoped=true&"
import script from "./documents-actions.vue?vue&type=script&lang=js&"
export * from "./documents-actions.vue?vue&type=script&lang=js&"
import style0 from "./documents-actions.vue?vue&type=style&index=0&id=ac8b2d58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8b2d58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac8b2d58')) {
      api.createRecord('ac8b2d58', component.options)
    } else {
      api.reload('ac8b2d58', component.options)
    }
    module.hot.accept("./documents-actions.vue?vue&type=template&id=ac8b2d58&scoped=true&", function () {
      api.rerender('ac8b2d58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/additions/data-table/documents-actions.vue"
export default component.exports